<template>
    <div class="recommend">
        <div class="recommend-content" v-bind:class="{pullleft: showMNav}">
            <div class="heading">
                <h1 v-show="show.content">推荐车型目录<span @click="showMNav = !showMNav"></span></h1>
                <div v-show="show.detail">
                    <span class="back" @click="goIndex()"></span>
                    <p class="title">详情</p>
                </div>
                <div v-show="show.picker">
                    <span class="back" @click="goIndex()"></span>
                    <p class="title">筛选条件</p>
                    <p class="reset" @click="resetPickerData()">还原默认</p>
                </div>
                <div v-show="show.checkBoxPicker">
                    <span class="back" @click="goPicker()"></span>
                    <p>{{checkBoxHead}}</p>
                    <p class="reset" @click="confirmCheckBoxData()">确认</p>
                </div>
            </div>
            <div class="content" id="content" v-show="show.content">
                <div class="picker-btn" @click="goPicker()">
                    <div class="total">
                        共有<span>{{total}}</span>条
                    </div>
                    <div class="right">
                        <span class="picker">筛选</span>
                        <i class="right-icon"></i>
                    </div>
                </div>
                <div class="list-item">
                    <!-- <div class="category-title">
                        纯电动货车
                    </div> -->
                    <ul>
                        <li v-for="(item, index) in pageData" @click="goDetail(index)">
                            <div class="car-info">
                                <div class="left">
                                    <p class="notification-number">
                                        {{item.notice_num}}
                                        <span class="free-icon" v-show="item.is_free_tax == 1">免</span>
                                        <span class="subsidy-icon" v-show="item.is_subsidy == 1">补</span>
                                    </p>
                                    <p class="company-name">{{item.enterprise_name}}</p>
                                </div>
                                <div class="right">
                                    <div>
                                        <p class="brand-name">{{item.brand}}</p>
                                        <p class="car-type">{{item.car_type}}</p>
                                    </div>
                                    <i class="right-icon"></i>
                                </div>
                            </div>
                            <div class="car-source">第{{item.batch}}批推荐目录·公告序号{{item.serial_number}}</div>
                        </li>
                    </ul>
                </div>
                <div class="download">
                    <img src="../../static/img/filter.svg" alt="下载" @click="downloadResult()">
                </div>
            </div>
            <div class="detail" v-show="show.detail">
                <div class="section">
                    <div class="item">
                        <p class="item-title">车辆公告号</p>
                        <h2>
                            {{detail.notice_num}}
                            <span class="free-icon" v-show="detail.is_free_tax == 1">免</span>
                            <span class="subsidy-icon" v-show="detail.is_subsidy == 1">补</span>
                        </h2>
                    </div>
                    <div class="item">
                        <p class="item-title">企业名</p>
                        <p class="item-content">{{detail.enterprise_name}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">品牌</p>
                        <p class="item-content">{{detail.brand}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">新能源车类型</p>
                        <p class="item-content">{{detail.car_type}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">推荐目录批次</p>
                        <p class="item-content">第{{detail.batch}}批推荐目录</p>
                    </div>
                    <div class="item">
                        <p class="item-title">公告序号</p>
                        <p class="item-content">公告序号{{detail.serial_number}}</p>
                    </div>
                </div>
                <div class="section">
                    <div class="item">
                        <p class="item-title">配置ID</p>
                        <p class="item-content">{{detail.configure_id}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">电池系统供应商</p>
                        <p class="item-content">{{detail.battery_system}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">电驱动系统供应商</p>
                        <p class="item-content">{{detail.electric_drive}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">超级电容供应商</p>
                        <p class="item-content">{{detail.ultracapacitor}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">发动机供应商</p>
                        <p class="item-content">{{detail.engine}}</p>
                    </div>
                </div>
                <div class="section">
                    <div class="item">
                        <p class="item-title">纯电续驶里程（km）</p>
                        <p class="item-content">{{detail.ev_mileage}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">发动机排量（mL）</p>
                        <p class="item-content">{{detail.engine_output}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">整车整备质量（kg）</p>
                        <p class="item-content">{{detail.quality}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">动力蓄电池组总能量（kWh）</p>
                        <p class="item-content">{{detail.battery_power}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">燃料消耗量（L/100km）</p>
                        <p class="item-content">{{detail.fuel_wastage}}</p>
                    </div>
                    <div class="item">
                        <p class="item-title">动力蓄电池组总质量（kg）</p>
                        <p class="item-content">{{detail.battery_quality}}</p>
                    </div>
                </div>
            </div>
            <div class="picker-condition" v-show="show.picker">
                <div class="section">
                    <div class="item" @click="goCheckBoxPicker('enterprise_name')">
                        <div class="left">
                            企业名
                        </div>
                        <div class="right">
                            <p>{{searchParams.enterprise_name || '不限'}}</p>
                            <span class="right-icon"></span>
                        </div>
                    </div>
                    <div class="item">
                        <div class="left">
                            品牌
                        </div>
                        <div class="right">
                            <p>{{searchParams.brand || '不限'}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.brand">
                            <option v-for="item in pickerCondition.brand" :value="item">{{item}}</option>
                        </select>
                    </div>
                    <div class="item" @click="goCheckBoxPicker('car_type')">
                        <div class="left">
                            新能源车类型
                        </div>
                        <div class="right">
                            <p>{{searchParams.car_type || '不限'}}</p>
                            <span class="right-icon"></span>
                        </div>
                    </div>
                </div>
                <div class="section">
                    <div class="item">
                        <div class="left">
                            电池系统供应商
                        </div>
                        <div class="right">
                            <p>{{searchParams.battery_system || '暂无'}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.battery_system">
                            <option v-for="item in pickerCondition.battery_system" :value="item">{{item}}</option>
                        </select>
                    </div>
                    <div class="item">
                        <div class="left">
                            电驱动系统供应商
                        </div>
                        <div class="right">
                            <p>{{searchParams.electric_drive || '暂无'}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.electric_drive">
                            <option v-for="item in pickerCondition.electric_drive" :value="item">{{item}}</option>
                        </select>
                    </div>
                    <div class="item">
                        <div class="left">
                            超级电容供应商
                        </div>
                        <div class="right">
                            <p>{{searchParams.ultracapacitor || '暂无'}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.ultracapacitor">
                            <option v-for="item in pickerCondition.ultracapacitor" :value="item">{{item}}</option>
                        </select>
                    </div>
                    <div class="item">
                        <div class="left">
                            发动机供应商
                        </div>
                        <div class="right">
                            <p>{{searchParams.engine || '暂无'}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.engine">
                            <option v-for="item in pickerCondition.engine" :value="item">{{item}}</option>
                        </select>
                    </div>
                </div>
                <div class="section">
                    <div class="item">
                        <div class="left">
                            是否免税
                        </div>
                        <div class="right">
                            <p>{{searchParams.is_free_tax | repairParams}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.is_free_tax">
                            <option value="1">是</option>
                            <option value="0">否</option>
                        </select>
                    </div>
                    <div class="item">
                        <div class="left">
                            是否补贴
                        </div>
                        <div class="right">
                            <p>{{searchParams.is_subsidy | repairParams}}</p>
                            <span class="right-icon"></span>
                        </div>
                        <select v-model="searchParams.is_subsidy">
                            <option value="1">是</option>
                            <option value="0">否</option>
                        </select>
                    </div>
                </div>
                <button type="button" name="button" @click="pickerData()">筛选</button>
            </div>
            <div class="car-style-picker" v-show="show.checkBoxPicker">
                <div v-for="(item, index) in checkBoxData" :class="{on: onClassList[index]}" @click="toggleClass(index)">
                    {{item}}
                </div>
            </div>
        </div>
        <Mnav :showMNav="showMNav"></Mnav>
        <div class="mask" v-show="showMNav"></div>
    </div>
</template>

<script>
    import Mnav from './Mnav'
    import axios from 'axios'

    export default {
        components: {
            Mnav
        },
        data() {
            return {
                isLogin: false,
                showMNav: false,
                total: 0,
                show: {
                    content: true,
                    detail: false,
                    picker: false,
                    checkBoxPicker: false
                },
                pageData: [],
                // 多选数据
                checkBoxData: [],
                // 多选头部文字
                checkBoxHead: '',
                // 多选确认是哪个选项
                checkBoxOption: '',
                // 多选点击on类名列表
                onClassList: [],
                getBrandFlag: false,
                detail: {},
                // 筛选结果
                searchParams: {
                    page: 1,
                    enterprise_name: '',
                    brand: '',
                    car_type: '',
                    battery_system: '',
                    electric_drive: '',
                    ultracapacitor: '',
                    engine: '',
                    is_free_tax: '1',
                    is_subsidy: '1'
                },
                // 筛选条件
                pickerCondition: {},
                scrollFlag: true
            }
        },
        mounted() {
            this.$nextTick(function () {
                this.getData();
            });
            window.addEventListener('scroll', () => {
                if(!this.show.content) {
                    return false;
                }
                var dst = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;;
                //网页可见区域高
                var dch = document.getElementById('content').scrollHeight;
                //屏幕可用工作区高度
                var wsa = window.screen.availHeight;
                if ((dch-wsa)-dst < 200) {
                    if (!this.scrollFlag) { //防止多次加载
                        this.scrollFlag = true;
                        this.searchParams.page++;
                        this.getData()
                    }
                }
            })
        },
        filters: {
            repairParams: function(v) {
                // if(v == '不限') {
                //     result = '不限';
                // }else {
                //     result = v == 1 ? '是' : '否';
                // }
                return v == 1 ? '是' : '否';
            }
        },
        methods: {
            // 获取数据
            getData(type) {
                let that = this;
                axios.get('/api/car/recommended/car',{
                    params: that.searchParams
                }).then((res) => {
                    console.log(res.data);
                    that.scrollFlag = false;
                    that.total = res.data.data.total;
                    // 通过参数判断是下滑拉取数据还是筛选获取数据
                    if(type === 'picker') {
                        that.pageData = res.data.data.data;
                    }else {
                        that.pageData = that.pageData.concat(res.data.data.data);
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            // 获取下拉选择项
            getPickerData() {
                let that = this;
                axios.get('/api/car/recommended/select_option',).then((res) => {
                    console.log(res.data);
                    that.pickerCondition = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            // 筛选按钮获取数据，将page重置为1
            pickerData() {
                this.searchParams.page = 1;
                this.getData('picker');
                this.choiceShow('content');
            },
            // 将筛选数据还原为默认
            resetPickerData() {
                this.searchParams = {
                    page: 1,
                    enterprise_name: '',
                    brand: '',
                    car_type: '',
                    battery_system: '',
                    electric_drive: '',
                    ultracapacitor: '',
                    engine: '',
                    is_free_tax: '',
                    is_subsidy: ''
                };
            },
            // 选择展示界面
            choiceShow(m) {
                for(var key in this.show) {
                    this.show[key] = false;
                }
                this.show[m] = true;
            },
            goIndex() {
                this.choiceShow('content');
            },
            goPicker() {
                this.choiceShow('picker');
                this.getPickerData();
            },
            goDetail(index) {
                // 需要把滑动条置于顶部
                document.documentElement.scrollTop=0;
                this.choiceShow('detail');
                let that = this;
                that.detail = that.pageData[index];
            },
            goCheckBoxPicker(type) {
                if(type === 'car_type') {
                    this.checkBoxHead = '新能源车类型（多选）';
                    this.checkBoxOption = 'car_type';
                    this.checkBoxData = this.pickerCondition.car_type;
                }else {
                    this.checkBoxHead = '企业名（多选）';
                    this.checkBoxOption = 'enterprise_name';
                    this.checkBoxData = this.pickerCondition.enterprise_name;
                }
                this.choiceShow('checkBoxPicker');
            },
            // 多选时ui展示
            toggleClass(index) {
                if(!this.onClassList[index]) {
                    this.$set(this.onClassList, index, true)
                }else {
                    this.$set(this.onClassList, index, false)
                }
            },
            // 确认多选内容，如果是选择企业名 则根据企业名选择品牌，
            // 如果企业名超过1个 则无法选择品牌。
            confirmCheckBoxData() {
                var tempArr = [];
                for (var i = 0; i < this.onClassList.length; i++) {
                    if (this.onClassList[i]) {
                        tempArr.push(this.checkBoxData[i]);
                    }
                }
                if(this.checkBoxOption === 'enterprise_name') {
                    this.searchParams.enterprise_name = tempArr.join(',');
                    if(tempArr.length > 1) {
                        this.getBrandFlag = true;
                    }else {
                        this.getBrandFlag = false;
                        this.getBrand();
                        // 如果修改企业名后，需要将品牌清空
                        this.pickerCondition.brand = [];
                        this.searchParams.brand = '';
                    }
                }else {
                    this.searchParams.car_type = tempArr.join(',');
                }
                this.onClassList = [];
                this.choiceShow('picker');
            },
            getBrand() {
                if(this.getBrandFlag) {
                    alert('在选择多个企业时禁止选择品牌');
                    return false;
                }
                // 防止重复请求 如果有则返回
                if(this.pickerCondition.brand && this.pickerCondition.brand.length === 1) {
                    return false;
                }
                let that = this;
                axios.get('/api/car/recommended/get_brand',{
                    params: {
                        enterprise_name: that.searchParams.enterprise_name
                    }
                }).then((res) => {
                    console.log(res.data);
                    that.pickerCondition.brand = res.data.data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            downloadResult() {
                var count = 0, s = '';
                for (var oKey in this.searchParams) {
                    if (this.searchParams[oKey]) {
                        count ++;
                        s += oKey + '=' + this.searchParams[oKey] + '&';
                    }
                }
                this.createDownload('/api/car/recommended/download_car_excel?' + s.slice(0, -1));
            },
            createDownload (content) {
                var IFrameRequest = document.createElement("iframe");
                IFrameRequest.id = "IFrameRequest";
                IFrameRequest.src = content;
                IFrameRequest.style.display="none";
                document.body.appendChild(IFrameRequest);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .recommend {
        h1 {
            position: relative;
            width: 100%;
            height: 60px;
            padding: 0;
            background-color: #0666b2;
            font-size: 20px;
            color: #D1DFE9;
            line-height: 60px;
            text-align: center;
            span {
                position: absolute;
                top: 17px;
                right: 17px;
                width: 26px;
                height: 26px;
                background-image: url("../../static/img/toggle.png");
                background-size: 100%;
                background-repeat: no-repeat;
            }
        }
        .heading {
            div {
                position: relative;
                width: 100%;
                height: 60px;
                padding: 0;
                background-color: #0666b2;
                font-size: 19px;
                color: #fff;
                line-height: 60px;
                text-align: center;
                .back {
                    position: absolute;
                    top: 21px;
                    left: 15px;
                    width: 10px;
                    height: 17px;
                    background-image: url("../../static/img/left.png");
                    background-size: 100%;
                    background-repeat: no-repeat;
                }
                .reset {
                    position: absolute;
                    top: 0;
                    right: 15px;
                    font-size: 14px;
                }
            }
        }
        &-content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #eee;
            transition: -webkit-transform 0.33s cubic-bezier(0.29, 0.05, 0.14, 0.87);
        }
    }
    .pullleft {
        height: 100%;
        overflow: hidden;
        transform: translateX(-270px);
    }
    .picker-btn {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        width: 100%;
        height: 47px;
        font-size: 15px;
        box-sizing: border-box;
        line-height: 47px;
        background-color: #fff;
        span {
            color: #0666b2;
        }
        .picker {
            position: relative;
            margin-right: 10px;
            &:before {
                content: "";
                position: absolute;
                top: 50%;
                left: -24px;
                width: 20px;
                height: 18px;
                margin-top: -10px;
                background-image: url("../../static/img/picker.png");
                background-size: 100%;
                background-repeat: no-repeat;
            }
        }
        .right {
            display: flex;
            align-items: center;
        }
    }
    .right-icon {
        display: inline-block;
        width: 9px;
        height: 17px;
        background-image: url("../../static/img/right.png");
        background-size: 100%;
        background-repeat: no-repeat;
    }
    .category-title {
        width: 100%;
        height: 27px;
        padding-left: 15px;
        background-color: #eee;
        color: #999;
        font-size: 11px;
        line-height: 27px;
    }

    .list-item {
        ul {
            padding: 0 15px;
            background-color: #fff;
        }
        li {
            position: relative;
            padding: 17px 0 16px;
            &:not(:last-child) {
                border-bottom: 1px solid #eee;
            }
        }
        .car-info {
            display: flex;
            justify-content: space-between;
            .right {
                width: 140px;
            }
        }
        .right-icon {
            position: absolute;
            right: 0;
            top: 50%;
            margin-top: -9px;
        }
        .notification-number,
        .brand-name {
            margin-bottom: 8px;
            font-size: 16px;
        }
        .company-name,
        .car-type {
            margin-bottom: 16px;
            font-size: 11px;
        }
        .car-source {
            font-size: 11px;
            color: #999;
        }
    }
    .free-icon,
    .subsidy-icon {
        display: inline-block;
        width: 16px;
        height: 16px;
        margin-left: 6px;
        border-radius: 2px;
        color: #fff;
        font-size: 12px;
        line-height: 16px;
        text-align: center;
    }
    .subsidy-icon {
        background: #F97C99;
    }
    .free-icon {
        background: #62BBEE;
    }
    .detail {
        padding: 0 15px 74px;
        background-color: #fff;
        .section {
            padding-top: 15px;
            &:not(:last-child) {
                border-bottom: 1px solid #eee;
            }
        }
        .item {
            margin-bottom: 20px;
        }
        p, h2 {
            line-height: 1;
        }
        .item-title {
            margin-bottom: 6px;
            font-size: 11px;
            color: #999;
        }
        .item-content {
            font-size: 15px;
            color: #000;
        }
        h2 {
            font-size: 20px;
            color: #000;
        }
    }
    .picker-condition {
        position: absolute;
        top: 60px;
        left: 0;
        width: 100%;
        height: calc(100% - 60px);
        background-color: #f8f8f8;
        .section {
            margin-top: 10px;
            padding: 0 15px;
            background-color: #fff;
        }
        .item {
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 14px 0 13px;
            font-size: 15px;
            &:not(:last-child) {
                border-bottom: 1px solid #eee;
            }
            p {
                display: inline-block;
                width: 150px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                text-align: right;
            }
            .right-icon {
                height: 15px;
                margin-left: 10px;
            }
            select {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 9;
                opacity: 0;
            }
        }
        button {
            display: block;
            width: 92%;
            height: 54px;
            margin: 60px auto 0;
            padding: 0;
            border: 0;
            background-color: #0666b2;
            border-radius: 2px;
            font-size: 17px;
            line-height: 54px;
            text-align: center;
            color: #fff;
        }
    }
    .car-style-picker {
        margin-top: 10px;
        padding: 0 15px;
        background-color: #fff;
        div {
            position: relative;
            width: 100%;
            height: 42px;
            line-height: 42px;
            font-size: 15px;
            &:not(:last-child) {
                border-bottom: 1px solid #eee;
            }
            &.on {
                color: #0666b2;
                &:after {
                    content: "√";
                    position: absolute;
                    top: 0;
                    right: 0;
                }
            }
        }
    }
    .download {
        position: fixed;
        bottom: 0;
        left: 50%;
        width: 80px;
        height: 80px;
        margin-left: -40px;
        padding-bottom: 10px;
        background-color: #fff;
        text-align: center;
        background-color: transparent;
        img {
            vertical-align: middle;
        }
    }
    .mask {
        position: fixed;
        top: 60px;
        left: 0;
        width: calc(100% - 270px);
        height: calc(100% - 60px);
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// Recommend.vue?55974696